import { Link } from 'react-router-dom';
import { useData } from '../../context/DataContext';
import './HowItWorks.css';

export default function HowItWorks() {
  const { data } = useData();
  const howItWorks = data?.howItWorks || [];

  return (
    <section className="section how-it-works">
      <div className="container">
        <div className="section-title section-title--center">
          <span className="section-title__label">Getting Started</span>
          <h2 className="section-title__heading">How It Works</h2>
        </div>

        <div className="how-it-works__grid">
          {howItWorks.map(item => (
            <div key={item.step} className="how-it-works__step">
              <div className="how-it-works__number">{item.step}</div>
              <h3 className="how-it-works__title">{item.title}</h3>
              <p className="how-it-works__description">{item.description}</p>
            </div>
          ))}
        </div>

        <div className="how-it-works__cta">
          <Link to="/products" className="btn btn--primary btn--lg">Get Started</Link>
        </div>
      </div>
    </section>
  );
}
